import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { ISelectRealtorFormState } from '@cian/valuation-main-filters-widget';
import { pickBy, isNil, complement } from 'ramda';

import { getSiteType } from '../../utils/getSiteType';

export function trackGoToAllRealtors() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PodborRieltora',
    action: 'Click',
    label: 'GoToRealtors',
  });
}

export enum ETrackGoToApplicationFormLabel {
  Main = 'Main',
  Search = 'Search',
  Podbor = 'Podbor',
  Contact = 'Contact',
}

interface IOptions extends ISelectRealtorFormState {
  deviceType: TDeviceType;
}

export function trackGoToApplicationForm(label: ETrackGoToApplicationFormLabel, options?: IOptions) {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const params: Record<any, any> = {
    name: 'oldevent',
    category: 'PodborRieltora',
    action: 'Click',
    label: `GoToApplicationForm/${label}`,
  };

  /**
   * Когда переход на форму риелтора произойдет из главного блока с фильтрами,
   * дополнительно отправятся значения всех фильтров в page.extra
   * */
  if (options) {
    params.page = {
      pageType: 'PodborRieltora',
      siteType: getSiteType(options.deviceType),
      extra: pickBy(complement(isNil), {
        dealType: options.dealType,
        offerType: options.offerType,
        objectType: options.objectType,
      }),
    };
  }

  ca('eventSite', params);
}

export enum EBlock {
  Search = 'Search',
  Main = 'Main',
  RealtorBenefits = 'RealtorBenefits',
  Contact = 'Contact',
  HowItWorks = 'HowItWorks',
  FAQ = 'FAQ',
  Podbor = 'Podbor',
}

export function trackBlockIntoView(block: EBlock) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PodborRieltora',
    action: 'scroll_sopr',
    label: block,
  });
}

export const trackSearchIntoView = trackBlockIntoView.bind(null, EBlock.Search);
export const trackMainIntoView = trackBlockIntoView.bind(null, EBlock.Main);
export const trackRealtorBenefitsIntoView = trackBlockIntoView.bind(null, EBlock.RealtorBenefits);
export const trackContactIntoView = trackBlockIntoView.bind(null, EBlock.Contact);
export const trackHowItWorksIntoView = trackBlockIntoView.bind(null, EBlock.HowItWorks);
export const trackFAQIntoView = trackBlockIntoView.bind(null, EBlock.FAQ);
export const trackPodborIntoView = trackBlockIntoView.bind(null, EBlock.Podbor);
